module.exports = __webpack_public_path__ + "static/media/m1.51db3534.svg";